<ng-container *ngIf="controlName.errors && (controlName.touched || controlName.dirty)">
  <div class="master-div">

    <p *ngIf="controlName.errors?.['email']"
       class="error">Email format is not correct</p>

    <ng-container *ngIf="controlName.errors?.['min']">
      <p class="error">Value should be larger than {{controlName.errors.min.min}}</p>
    </ng-container>

    <ng-container *ngIf="controlName.errors?.['max']">
      <p class="error">Value should be less than {{controlName.errors.max.max}}</p>
    </ng-container>

    <ng-container *ngIf="controlName.errors?.['minlength']">
      <p class="error">Length is less than {{controlName.errors.minlength.requiredLength}}</p>
    </ng-container>

    <ng-container *ngIf="controlName.errors?.['maxlength']">
      <p class="error">Length is greater than {{controlName.errors.maxlength.requiredLength}}</p>
    </ng-container>

    <p *ngIf="controlName.errors?.['required']"
       class="error">This field is Required</p>

    <p *ngIf="controlName.errors?.invalid"
       class="error">INVALID</p>
  </div>
</ng-container>
